export default angular.module('content_delivery_system', []);